module.exports = __webpack_public_path__ + "img/party.2289bc62.png";